import ConnectEtsyShopSuccess from './ConnectEtsyShopSuccess.vue';

export default ConnectEtsyShopSuccess;
